import { PartialType } from '../../../utils';
import { CreateGarageDto } from './create-garage.dto';
export class UpdateGarageDto extends PartialType(CreateGarageDto) {
}
